<ul
	#tagList
	[class]="tagDisplayType === 'list' ? 'tags-list-no-bubble' : 'tags-list'"
>
	@for(tag of displayedTags; track tag){
	<li
		[class]="tagDisplayType === 'list' ? 'plain-tag' : 'bubble-tag'"
		[ngClass]="{ 'white-background': useWhiteBackground }"
		[ngStyle]="marginForWrapping"
		title="{{ tag }}"
	>
		@if(allowEliding) {
		<span [ngClass]="elisionClasses(tag)" (click)="tagClicked(tag)">{{
			tag
		}}</span>
		} @else {
		<span class="tag-if-all" (click)="tagClicked(tag)">{{ tag }}</span>
		}
	</li>
	} @if(allowEliding && hasHiddenTags) {
	<li
		class="bubble-tag-more"
		(click)="moreClicked()"
		title="and {{ hiddenTagsCount }} more tags"
	>
		+{{ hiddenTagsCount }}...
	</li>
	}
</ul>
